import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ContentChild, TemplateRef, HostBinding } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CfSelectableComponent } from '../selectable/selectable.component';
import { SelectableModel } from '../../models/selectable/selectable.model';
import { SelectableStylingModel } from '../../models/selectable/selectable-styling.model';
import { RadioTemplates } from '../../templates/radio.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Radio Component</p>
 * <pre>
 * <code>
 * import {{'{'}} SelectableModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} SelectableStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-radio<code>></code><code><</code><code>/</code>cf-radio<code>></code>
 * </code>
 * </pre>
 */
export class CfRadioComponent extends CfSelectableComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden
 */
cfRadioTemplate;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new SelectableModel();
    this.styling = new SelectableStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('radio', RadioTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'RADIO').then( sampler => {
        this.checked = this.properties.checked;
        if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
        // console.log('RADIO', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
radioNotifyGroup() {
    this.selected = !this.selected;
    this.checked = this.selected;
    this.notifyGroup();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-radio',
  template: "<cf-selectable> <div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-selectable'\"> <div class=\"cf-radio-button {{properties?.itemPosition}}\" [class.has-no-item]=\"hasNoItem\" (click)=\"radioNotifyGroup()\"> <md-radio-group> <md-radio-button class=\"{{activeTemplate.style?.button?.class}} {{styling?.button?.class}} {{getDynamicClasses(activeTemplate.style?.button?.dynamicClass)}} {{getDynamicClasses(styling?.button?.dynamicClass)}}\" [ngClass]=\"'cf-checkbox'\" [checked]=\"checked\" [value]=\"properties?.value\" [labelPosition]=\"properties?.itemPosition\" [ngClass]=\"'cf-radio'\" [disabled]=\"properties?.disable\" [color]=\"styling?.button?.themeColor || activeTemplate.style?.button?.themeColor\"> <div *ngIf=\"!cfRadioTemplate && !!properties?.item\" [innerHtml]=\"properties?.item | safePipe\"></div> <div *ngIf=\"cfRadioTemplate\" [ngTemplateOutlet]=\"cfRadioTemplate\" [ngOutletContext]=\"{cfIndex: i, cfItem: properties?.item}\"></div> </md-radio-button> </md-radio-group> </div> <cf-notification *ngIf=\"notification && (notification?.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </div> </cf-selectable>",
  styles: [":host { position: relative; z-index: 0; display: inline-flex; } :host.notification-clickable cf-notification:hover { cursor: pointer; } .cf-radio-group-container { display: inline-block; } md-radio-group { display: flex; flex-direction: column; } md-radio-group md-radio-button { align-items: center; padding: 2px 0px; } :host /deep/ .mat-radio-label { display: flex; align-items: center; } :host /deep/ .before .mat-radio-label { justify-content: flex-end; } :host /deep/ .mat-radio-container { top: 0px !important; } :host /deep/ .has-no-item .mat-radio-label-content { padding-left: 0px; padding-right: 0px; } [hidden] { display: none !important; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'cfRadioTemplate': [{ type: ContentChild, args: [TemplateRef, ] },],
};
}

function CfRadioComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfRadioComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfRadioComponent.ctorParameters;
/** @type {?} */
CfRadioComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfRadioComponent.prototype.notificationClickable;
/**
 * @hidden
 * @type {?}
 */
CfRadioComponent.prototype.cfRadioTemplate;
/**
 * @hidden
 * @type {?}
 */
CfRadioComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
